<template>
  <section class="page-interaction account-status-page">
    <b-overlay :show="loading" no-center variant="transparent" rounded="sm">
      <template #overlay>
        <loading-spinner />
      </template>

      <!-- Sekmeler (bağlantılar aynı) -->
      <nav class="as-tabs">
        <RouterLink
          :to="{name: mobile ? 'account-status-mobile' : 'account-status'}"
          class="as-tab active"
        >
          {{ $t('Account Status') }}
        </RouterLink>
        <RouterLink
          :to="{name: mobile ? 'gains-mobile' : 'gains'}"
          class="as-tab"
        >
          {{ $t('My Gains') }}
        </RouterLink>
        <RouterLink
          :to="{name: mobile ? 'cashouts-mobile' : 'cashouts'}"
          class="as-tab"
        >
          {{ $t('Cashouts Page Title') }}
        </RouterLink>
      </nav>

      <div v-if="data" class="as-content">
        <!-- Bakiye kartı -->
        <div class="as-hero">
          <span class="as-hero__glow" aria-hidden="true" />
          <div class="as-hero__label">
            {{ $t('Current beans') }}
          </div>
          <div class="as-hero__amount">
            <span class="as-hero__bean">
              <b-img :src="iconBean" width="30" />
            </span>
            <span class="total-gains-text">
              {{ numberFormatter(data.earnedCredits) }}
            </span>
          </div>

          <div
            v-if="data.earnedCredits !== null && data.minCreditsForCashout"
            class="as-progress"
          >
            <div class="as-progress__head">
              <span>{{ $t('Beans needed for cashout') }}</span>
              <strong>{{ cashoutPercent }}%</strong>
            </div>
            <div
              class="as-progress__track"
              role="progressbar"
              :aria-valuenow="cashoutPercent"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                class="as-progress__fill"
                :style="{ width: cashoutPercent + '%' }"
              />
            </div>
            <div class="as-progress__foot">
              <span>{{ numberFormatter(data.earnedCredits) }}</span>
              <span>
                <b-img :src="iconBean" width="12" class="mr-25" />
                {{ numberFormatter(data.minCreditsForCashout) }}
              </span>
            </div>
          </div>
          <p
            v-else
            class="as-hero__hint"
          >
            {{ $t('Beans needed for cashout') }} :
            {{ numberFormatter(data.minCreditsForCashout) }}
          </p>

          <p
            v-if="data.minCreditsForCashout === 171000"
            class="as-hero__note"
          >
            {{ $t('minCreditsForCashout171k') }}
          </p>
        </div>

        <!-- Kazanç dağılımı -->
        <div class="as-breakdown">
          <!-- Canlı yayın (kapalı)
          <div class="as-row">
            <span class="as-row__icon"><feather-icon icon="RadioIcon" size="18" /></span>
            <span class="as-row__label">{{ $t('Live Streaming') }}</span>
            <span class="as-row__value">{{ numberFormatter(data.earnedCreditsStreamGift) }}</span>
          </div>
          -->
          <div class="as-row">
            <span class="as-row__icon as-row__icon--video">
              <feather-icon icon="VideoIcon" size="18" />
            </span>
            <span class="as-row__label gains-text">{{ $t('Video Call') }}</span>
            <span class="as-row__value">
              <b-img :src="iconBean" width="14" />
              {{ numberFormatter(data.earnedCreditsVideoCall) }}
            </span>
          </div>
          <!-- Rastgele arama (kapalı)
          <div class="as-row">
            <span class="as-row__icon"><feather-icon icon="ShuffleIcon" size="18" /></span>
            <span class="as-row__label">{{ $t('Random Call') }}</span>
            <span class="as-row__value">{{ numberFormatter(data.earnedCreditsRandomVideoCall) }}</span>
          </div>
          -->
          <div class="as-row">
            <span class="as-row__icon as-row__icon--voice">
              <feather-icon icon="PhoneIcon" size="18" />
            </span>
            <span class="as-row__label gains-text">{{ $t('Voice Call') }}</span>
            <span class="as-row__value">
              <b-img :src="iconBean" width="14" />
              {{ numberFormatter(data.earnedCreditsCall) }}
            </span>
          </div>
          <!-- Hediye satışı kaldırıldı — hediye geliri satırı gizlendi (toplam hesabında kalmaya devam ediyor)
          <div class="as-row">
            <span class="as-row__icon"><feather-icon icon="GiftIcon" size="18" /></span>
            <span class="as-row__label">{{ $t('Gifts') }}</span>
            <span class="as-row__value">{{ numberFormatter(data.earnedCreditsGift) }}</span>
          </div>
          -->
          <!-- Sohbet (kapalı)
          <div class="as-row">
            <span class="as-row__icon"><feather-icon icon="MessageCircleIcon" size="18" /></span>
            <span class="as-row__label">{{ $t('Chat') }}</span>
            <span class="as-row__value">{{ numberFormatter(data.earnedCreditsChat) }}</span>
          </div>
          -->
          <div class="as-row">
            <span class="as-row__icon as-row__icon--bonus">
              <feather-icon icon="StarIcon" size="18" />
            </span>
            <span class="as-row__label gains-text">{{ $t('Bonus') }}</span>
            <span class="as-row__value">
              <b-img :src="iconBean" width="14" />
              {{ numberFormatter(data.earnedCreditsBonusCredit) }}
            </span>
          </div>
          <div class="as-row">
            <span class="as-row__icon as-row__icon--tasks">
              <feather-icon icon="CheckCircleIcon" size="18" />
            </span>
            <span class="as-row__label gains-text">{{ $t('Daily tasks & rewards') }}</span>
            <span class="as-row__value">
              <b-img :src="iconBean" width="14" />
              {{ numberFormatter(data.earnedCreditsIncentive) }}
            </span>
          </div>
        </div>
      </div>
    </b-overlay>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert, BAvatar, BBadge, BButton, BCard, BCarousel, BCarouselSlide, BCol, BDropdown, BDropdownItem, BForm, BFormGroup,
  BFormInput, BFormTextarea, BImg, BLink, BListGroup, BListGroupItem, BMedia, BNav, BNavItem, BOverlay, BPagination,
  BProgress, BProgressBar, BRow, BSpinner, BTable, BTabs, BTab,
} from 'bootstrap-vue'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import useJwt from '@/auth/jwt/useJwt'
import {throwDefaultError, numberFormatter} from '@/helpers/helpers'
import StatusIndicator from '@/components/StatusIndicator'
import CallCard from '@/components/CallCard'
import vSelect from 'vue-select'
import moment from 'moment'
import _ from 'lodash'
import GiftCard from '@/components/GiftCard.vue'

export default {
  name: 'AccountStatusComponent',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GiftCard,
    BAlert,
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCarousel,
    BCarouselSlide,
    BCol,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BImg,
    BLink,
    BListGroup,
    BListGroupItem,
    BMedia,
    BNav,
    BNavItem,
    BOverlay,
    BPagination,
    BProgress,
    BProgressBar,
    BRow,
    BSpinner,
    BTable,
    BTabs,
    BTab,

    CallCard,
    StatusIndicator,

    Carousel3d,
    Slide,

    vSelect,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      activeTabIndex: 0,
      data: null,
      gainRequest: {
        accountHolder: '',
        bankName: '',
        iban: '',
      },
      iconBean: require('@/assets/images/icons/bean.png'),
      iconDiamond: require('@/assets/images/icons/diamonds-1.svg'),
      iconPhone: require('@/assets/images/icons/phone-green.svg'),
      limit: 300,
      loading: false,
      streamStatistics: null,
    }
  },
  computed: {
    // Önceki şablondaki formülün aynısı
    cashoutPercent() {
      if (!this.data || !this.data.minCreditsForCashout) return 0
      return Math.min(Math.round((this.data.earnedCredits / this.data.minCreditsForCashout) * 100), 100)
    },
  },
  created() {
    this.getGains()
  },
  methods: {
    numberFormatter,
    getGains() {
      this.loading = true

      useJwt.accountCredits()
          .then(response => {
            this.data = response.data.body
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
    },
    getDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    timeLeft(time) {
      if (time <= 0) return '0'

      let result = ''
      let totalSeconds = time;

      const days = Math.floor(totalSeconds / (60 * 60 * 24))
      totalSeconds -= days * (60 * 60 * 24)

      const hours = Math.floor(totalSeconds / (60 * 60))
      totalSeconds -= hours * (60 * 60)

      const minutes = Math.floor(totalSeconds / (60))
      totalSeconds -= minutes * 60

      const seconds = Math.floor(totalSeconds % 60)

      // if (days > 0) {
      //   result += days + ` ${this.$t('days')}, `
      // }

      if (hours > 0) {
        result += hours + ` ${this.$t('hours')}, `
      }

      if (minutes > 0) {
        result += minutes + ` ${this.$t('minutes')}, `
      }

      if (seconds > 0) {
        result += seconds + ` ${this.$t('seconds')}, `
      }

      return _.trimEnd(result, ', ')
    }
  }
}
</script>

<style lang="scss" scoped>
/* Boho koyu tema: lacivert zemin, pembe-mor vurgu, yuvarlak cam kartlar */
.account-status-page {
  --as-bg: #11172b;
  --as-card: rgba(32, 22, 72, 0.72);
  --as-border: rgba(150, 110, 255, 0.24);
  --as-text: #f4f1ff;
  --as-muted: rgba(226, 220, 255, 0.68);
  --as-pink: #ea03b2;
  --as-violet: #a855f7;

  /* Standart sayfa yerleşimi (Market sayfasıyla aynı kenar boşlukları) */
  padding: 18px 28px 40px;
  color: var(--as-text);
  font-family: 'Lexend', sans-serif;

  @media (max-width: 991px) { padding: 14px 16px 32px; }
  @media (max-width: 575px) { padding: 10px 8px 24px; }

  /* İçerik sayfanın ortasında */
  .as-tabs,
  .as-content {
    max-width: 760px;
    margin-left: auto;
    margin-right: auto;
  }
}

/* ---------- Sekmeler ---------- */
.as-tabs {
  display: flex;
  gap: 6px;
  padding: 5px;
  margin-bottom: 18px;
  border-radius: 9999px;
  background: rgba(14, 10, 40, 0.6);
  border: 1px solid var(--as-border);
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }
}

.as-tab {
  flex: 1 0 auto;
  text-align: center;
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 700;
  color: var(--as-muted) !important;
  transition: background .2s ease, color .2s ease;

  &:hover { color: #fff !important; }

  &.active {
    color: #fff !important;
    background: linear-gradient(135deg, rgba(234, 3, 178, 0.9) 0%, rgba(168, 85, 247, 0.9) 100%);
    box-shadow: 0 6px 18px rgba(234, 3, 178, 0.35);
  }
}

/* ---------- Bakiye kartı ---------- */
.as-hero {
  position: relative;
  overflow: hidden;
  padding: 24px 24px 20px;
  border-radius: 24px;
  background: linear-gradient(135deg, #2b1a63 0%, #1d1247 50%, #3a1356 100%);
  border: 1px solid rgba(234, 3, 178, 0.35);
  box-shadow: 0 14px 36px rgba(6, 2, 24, 0.45), 0 0 22px rgba(234, 3, 178, 0.12);

  &__glow {
    position: absolute;
    top: -80px;
    right: -60px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(234, 3, 178, 0.35), transparent 70%);
    pointer-events: none;
  }

  &__label {
    position: relative;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .3px;
    text-transform: uppercase;
    color: var(--as-muted);
    margin-bottom: 8px;
  }

  &__amount {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
  }

  &__bean {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(16, 185, 129, 0.14);
    border: 1px solid rgba(16, 185, 129, 0.4);

    img { filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.55)); }
  }

  &__hint,
  &__note {
    position: relative;
    margin: 10px 0 0;
    font-size: 12px;
    line-height: 1.5;
    color: var(--as-muted);
  }

  &__note {
    padding: 10px 12px;
    border-radius: 12px;
    background: rgba(14, 10, 40, 0.45);
    border: 1px solid rgba(170, 140, 255, 0.18);
  }
}

.total-gains-text {
  font-size: 34px;
  font-weight: 800;
  line-height: 1;
  color: #fff;
  letter-spacing: -0.5px;
}

/* ---------- İlerleme ---------- */
.as-progress {
  position: relative;

  &__head,
  &__foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: var(--as-muted);
  }

  &__head {
    margin-bottom: 8px;

    strong {
      font-size: 14px;
      color: #fff;
    }
  }

  &__foot {
    margin-top: 8px;

    span {
      display: inline-flex;
      align-items: center;
    }
  }

  &__track {
    height: 12px;
    border-radius: 9999px;
    background: rgba(14, 10, 40, 0.6);
    border: 1px solid rgba(170, 140, 255, 0.18);
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    min-width: 6px;
    border-radius: inherit;
    background: linear-gradient(90deg, #10b981 0%, #22c55e 45%, #a855f7 100%);
    box-shadow: 0 0 12px rgba(34, 197, 94, 0.55);
    transition: width .6s ease;
  }
}

/* ---------- Kazanç dağılımı ---------- */
.as-breakdown {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.as-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  background: var(--as-card);
  border: 1px solid var(--as-border);
  box-shadow: 0 8px 22px rgba(6, 2, 24, 0.3);

  &__icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(168, 85, 247, 0.22);

    &--video { background: linear-gradient(135deg, rgba(234, 3, 178, 0.55), rgba(168, 85, 247, 0.45)); }
    &--voice { background: linear-gradient(135deg, rgba(99, 102, 241, 0.6), rgba(168, 85, 247, 0.45)); }
    &--bonus { background: linear-gradient(135deg, rgba(245, 158, 11, 0.65), rgba(249, 115, 22, 0.5)); }
    &--tasks { background: linear-gradient(135deg, rgba(16, 185, 129, 0.6), rgba(34, 197, 94, 0.45)); }
  }

  &__label {
    flex: 1;
    min-width: 0;
  }

  &__value {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    white-space: nowrap;
  }
}

.gains-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: var(--as-text);
}

@media (max-width: 575px) {
  .as-hero { padding: 20px 16px 16px; border-radius: 20px; }
  .total-gains-text { font-size: 28px; }
  .as-tab { padding: 9px 12px; font-size: 12px; }
  .as-row { padding: 12px; }
}
</style>
